<template>
  <div>
    <breadcrumb v-bind:path2="path2"></breadcrumb>
    <div class="warehouseOrder">
      <el-form ref="orderForm" :model="orderForm">
        <div class="wrap">
          <div class="main">
            <main class="main__content">
              <div class="step__sections" v-if="!submmited">
                <div class="section section--shipping-address">
                  <!-- pickup information start-->
                  <div class="section__content" v-bind:style="{ marginBottom: 10 }">
                    <div class="title">
                      <span>{{ $t("pickupInfo") }}</span>
                    </div>
                    <div class="fieldset">
                      <el-row :gutter="20">
                        <el-col :span="8">
                          <el-form-item v-bind:label="$t('pickupDate')" prop="ShipmentDate">
                            <el-date-picker
                              v-model="orderForm.ShipmentDate"
                              type="date"
                              format="MM/dd/yyyy"
                              value-format="yyyy-MM-dd"
                              style="width:100%"
                              placeholder="MM/DD/YYYY"
                            >
                            </el-date-picker>
                          </el-form-item>
                        </el-col>
                      </el-row>
                      <el-row :gutter="20">
                        <el-col :span="16">
                          <div>
                            <el-form-item v-bind:label="$t('pickupLocation')" prop="Pickup_Warehouse_id">
                              <el-select
                                filterable
                                v-model="orderForm.Pickup_Warehouse_id"
                              >
                                <el-option
                                  v-for="address in warehouseAddresses"
                                  :label="`${address.formatted_address}`"
                                  :value="address.id"
                                  :key="address.id"
                                >
                                </el-option>
                              </el-select>
                            </el-form-item>
                          </div>
                        </el-col>
                        <el-col :span="8">
                        </el-col>
                      </el-row>
                      <el-row :gutter="20">
                        <el-col :span="24">
                          <span>{{ $t('pickupServices') }}</span>
                          <el-form-item prop="XPOAccessorials">
                            <el-checkbox-group v-model="orderForm.XPOAccessorials">
                              <el-checkbox
                                v-for="option in pickupServiceOptions"
                                :label="option"
                                :key="option"
                              >
                                {{ $t(option) }}
                              </el-checkbox>
                            </el-checkbox-group>
                          </el-form-item>
                        </el-col>
                      </el-row>
                    </div>
                  </div>
                  <!-- end pickup information -->
                  
                  <!-- delivery information start-->
                  <div class="section__content" v-bind:style="{ marginBottom: 10 }">
                    <div class="title">
                      <span>{{ $t("deliveryInfo") }}</span>
                    </div>
                    <div class="fieldset">
                      <el-row :gutter="20">
                        <el-col :span="16">
                          <div>
                            <el-form-item v-bind:label="$t('deliveryLocation')" prop="Billing_CustomerDetail_id">
                              <el-select
                                filterable
                                v-model="orderForm.Billing_CustomerDetail_id"
                              >
                                <el-option
                                  v-for="address in billingAddresses"
                                  :label="`${address.Street} ${address.City} ${address.State}, ${address.Zip}`"
                                  :value="address.CustomerDetail_id"
                                  :key="address.CustomerDetail_id"
                                >
                                </el-option>
                              </el-select>
                            </el-form-item>
                          </div>
                        </el-col>
                        <el-col :span="8">
                          <div class="title">
                            <button class="btn" @click.prevent="addressModalVisible = true">
                              <i class="el-icon-plus"></i><span>{{ $t("addNewAddress") }}</span>
                            </button>
                          </div>
                        </el-col>
                      </el-row>
                      <el-row :gutter="20">
                        <el-col :span="24">
                          <span>{{ $t('deliveryServices') }}</span>
                          <el-form-item prop="XPOAccessorials">
                            <el-checkbox-group v-model="orderForm.XPOAccessorials">
                              <el-checkbox
                                v-for="option in deliveryServicesOptions"
                                :label="option"
                                :key="option"
                              >
                                {{ $t(option) }}
                              </el-checkbox>
                            </el-checkbox-group>
                          </el-form-item>
                        </el-col>
                      </el-row>
                    </div>
                  </div>
                  <!-- end delivery information -->
                  
                  <!-- order info start -->
                  <div class="section__content" v-bind:style="{ marginBottom: 10 }">
                    <div class="title">
                      <span>{{ $t("orderInfo") }}</span>
                    </div>
                    <div class="fieldset">
                      <div class="customerInfoTable">
                        <el-row :gutter="20">
                          <el-col :span="6">
                            <el-form-item v-bind:label="$t('PDF file')">
                              <el-upload
                                :multiple="false"
                                :limit="1"
                                action=""
                                :on-remove="handleFileRemove"
                                :before-remove="beforeFileRemove"
                                :on-change="handleFileImport"
                                :auto-upload="false">
                                <el-button
                                  icon="el-icon-document"
                                  type="primary"
                                  circle>
                                </el-button>
                              </el-upload>
                            </el-form-item>
                          </el-col>
                        </el-row>
                        
                        <el-table
                          ref="multipleTableRef"
                          :data="inboundProducts"
                          style="width: 100%; marginBottom: 30px"
                          @selection-change="handleSelectionChange"
                          scrollbar-always-on
                          max-height="270"
                        >
                          <el-table-column type="selection" width="55" />
                          <el-table-column :label="$t('sku')" width="150">
                            <template #default="scope">{{ scope.row.RefNum }}</template>
                          </el-table-column>
                          <el-table-column property="Name" :label="$t('productName')" width="150" />
                          <el-table-column property="ProductNum" :label="$t('ProductNum')" width="150" />
                          <el-table-column property="Quantity" :label="$t('productQty')" width="120" />
                          <el-table-column property="NMFCClass" :label="$t('freightClass')" width="120" />
                          <el-table-column property="Remark" :label="$t('description')" width="120" />
                        </el-table>
                        <el-button
                          type="primary"
                          icon="el-icon-plus"
                          circle
                          @click="addNewLine"
                        ></el-button>
                        <el-row style="marginTop: 30px; marginBottom: 10px; float: right;">
                          <button class="btn" @click="openCalFreightClass($event)">
                            <span>{{ $t("calFreightClass") }}</span>
                          </button>
                          <!-- <a href="https://densitycalc.mybluegrace.com" target="_blank">{{ $t("calFreightClass") }}</a> -->
                        </el-row>
                        <el-table
                          :data="orderForm.lines"
                          border
                          style="width: 100%">
                          <el-table-column :label="$t('sku')" width="180">
                            <template slot-scope="scope">
                              <el-input disabled v-model="scope.row.RefNum"></el-input>
                            </template>
                          </el-table-column>
                          <el-table-column :label="$t('productName')" width="180">
                            <template slot-scope="scope">
                              <el-input disabled v-model="scope.row.Name"></el-input>
                            </template>
                          </el-table-column>
                          <el-table-column :label="$t('ProductNum')" width="180">
                            <template slot-scope="scope">
                              <el-input disabled v-model="scope.row.ProductNum"></el-input>
                            </template>
                          </el-table-column>
                          <el-table-column
                            :label="$t('palletQty')"
                            width="150"
                            prop="palletCount">
                            <template slot-scope="scope">
                              <el-input-number
                                style="width: 110px"
                                v-model="scope.row.PalletQuantity"
                                controls-position="right"
                                :min="0"
                              ></el-input-number>
                            </template>
                          </el-table-column>
                          <el-table-column :label="$t('weightLB')" width="120">
                            <template slot-scope="scope">
                              <el-input style="width: 80px" v-model="scope.row.PalletWeight"></el-input>
                            </template>
                          </el-table-column>
                          <el-table-column :label="$t('length')" width="120">
                            <template slot-scope="scope">
                              <el-input style="width: 80px" v-model="scope.row.PalletLength"></el-input>
                            </template>
                          </el-table-column>
                          <el-table-column :label="$t('width')" width="120">
                            <template slot-scope="scope">
                              <el-input style="width: 80px" v-model="scope.row.PalletWidth"></el-input>
                            </template>
                          </el-table-column>
                          <el-table-column :label="$t('height')" width="120">
                            <template slot-scope="scope">
                              <el-input style="width: 80px" v-model="scope.row.PalletHeight"></el-input>
                            </template>
                          </el-table-column>                          
                          <el-table-column :label="$t('freightClass')" width="180">
                            <template slot-scope="scope">
                              <el-input v-model="scope.row.NMFCClass"></el-input>
                            </template>
                          </el-table-column>
                          <!-- <el-table-column :label="$t('evc')" width="100">
                            <template slot-scope="scope">
                              <el-input style="width: 80px" v-model="scope.row.ExcessValue"></el-input>
                            </template>
                          </el-table-column> -->
                          <el-table-column :label="$t('carrierCommDesc')" width="180">
                            <template slot-scope="scope">
                              <el-input v-model="scope.row.Remark"></el-input>
                            </template>
                          </el-table-column>
                          <el-table-column label="Action" width="70">
                            <template slot-scope="scope">
                              <el-button
                                icon="el-icon-delete"
                                type="primary"
                                circle
                                @click.native.prevent="deleteRow(scope.$index,orderForm.lines)"
                              >
                              </el-button>
                            </template>
                          </el-table-column>
                        </el-table>
                      </div>
                    </div>
                  </div>
                  <!-- order info end -->
                  
                  <!-- note start-->
                  <div class="section__content" v-bind:style="{ marginBottom: 10 }">
                    <div class="title">
                      <!-- <span>{{ $t("note") }}</span> -->
                    </div>
                    <div class="fieldset">
                      <el-row :gutter="20">
                        <el-col :span="24">
                          <el-form-item v-bind:label="$t('note')" prop="RefNum">
                            <el-input
                              type="textarea"
                              :rows="2"
                              placeholder="Please input"
                              v-model="orderForm.RefNum">
                            </el-input>
                          </el-form-item>
                        </el-col>
                      </el-row>
                    </div>
                  </div>
                  <!-- end note -->
                  
                  <!-- Cal freight class modal -->
                  <el-dialog
                    v-bind:title="$t('calFreightClass')"
                    :visible.sync="calFreightClassVisible"
                    @close="closeCalFreightClass"
                    class="modal"
                    width='80%'
                  >
                  <div
                    class="section__content"
                    v-bind:style="{ marginBottom: 10 }">
                    <el-form
                      ref="freightClassForm"
                      :model="freightClassForm"
                    >
                    <div class="fieldset">
                      <div class="customerInfoTable">
                        <el-table
                          :data="freightClassForm.pallet"
                          border
                          style="width: 100%">
                          <el-table-column :label="$t('length')" width="120">
                            <template slot-scope="scope">
                              <el-input-number style="width: 90px" :controls=false v-model="scope.row.length"></el-input-number>
                            </template>
                          </el-table-column>
                          <el-table-column :label="$t('width')" width="120">
                            <template slot-scope="scope">
                              <el-input-number style="width: 90px" :controls=false v-model="scope.row.width"></el-input-number>
                            </template>
                          </el-table-column>
                          <el-table-column :label="$t('height')" width="120">
                            <template slot-scope="scope">
                              <el-input-number style="width: 90px" :controls=false v-model="scope.row.height"></el-input-number>
                            </template>
                          </el-table-column>
                          <el-table-column :label="$t('weight')" width="120">
                            <template slot-scope="scope">
                              <el-input-number style="width: 90px" :controls=false v-model="scope.row.weight"></el-input-number>
                            </template>
                          </el-table-column>
                          <el-table-column label="Action" width="70">
                            <template slot-scope="scope">
                              <el-button
                                icon="el-icon-delete"
                                type="primary"
                                circle
                                @click.native.prevent="deleteRow(scope.$index,freightClassForm.pallet)"
                              >
                              </el-button>
                            </template>
                          </el-table-column>
                        </el-table>
                      </div>
                      <el-button
                        type="primary"
                        icon="el-icon-plus"
                        circle
                        @click="addPallet"
                      ></el-button>
                      <div v-if="freightClassForm.error">
                        <span style="color: red">{{freightClassForm.error}}</span><br>
                      </div>
                      <div v-else>
                        <span>total cubes: {{freightClassForm.totalCubes}} (cu ft)</span><br>
                        <span>Total weight: {{freightClassForm.totalWeight}} (lbs)</span><br>
                        <span>Total density: {{freightClassForm.totalDensity}} (lb/cu ft)</span><br>
                        <span>Estimated Freight class: {{freightClassForm.freightClass}}</span>
                      </div>
                      <span class="end">
                        <button class="btn" @click="getFreightClass($event)">{{ $t('calculate') }}</button>
                        <button class="btnClose" @click="resetFreightClass($event)">{{ $t('reset') }}</button>
                      </span>
                    </div>
                    </el-form>
                  </div>
                  </el-dialog>
                  <!-- end Cal freight class modal -->
                  
                  <!-- add address -->
                  <el-dialog
                    v-bind:title="$t('addNewAddress')"
                    :visible.sync="addressModalVisible"
                    @close="handleClose"
                    class="modal"
                  >
                    <el-form
                      ref="addAddressForm"
                      :model="addAddressForm"
                    >
                      <div class="fieldset">
                        <div class="field">
                          <div v-if="errorAdding" class="time_tip">
                            <span>{{ $t("correctErrors") }}</span>
                          </div>
                          <el-row :gutter="20">
                            <el-col :span="12">
                              <div class="width">
                                <el-form-item
                                  prop="FirstName"
                                  v-bind:label="$t('firstName')"
                                >
                                  <el-input
                                    v-bind:placeholder="$t('firstName')"
                                    v-model="addAddressForm.FirstName"
                                  ></el-input>
                                </el-form-item>
                              </div>
                            </el-col>
                            <el-col :span="12">
                              <div class="width">
                                <el-form-item
                                  prop="LastName"
                                  v-bind:label="$t('lastName')"
                                >
                                  <el-input
                                    v-bind:placeholder="$t('lastName')"
                                    v-model="addAddressForm.LastName"
                                  ></el-input>
                                </el-form-item>
                              </div>
                            </el-col>
                          </el-row>
                          <el-row :gutter="20">
                            <el-col :span="12">
                              <div>
                                <el-form-item
                                  prop="AddressName"
                                  v-bind:label="$t('companyName')"
                                >
                                  <el-input
                                    v-bind:placeholder="$t('companyName')"
                                    v-model="addAddressForm.AddressName"
                                  ></el-input>
                                </el-form-item>
                                </div>
                              </el-col>
                            <el-col :span="12">
                              <div class="width">
                                <el-form-item
                                  prop="Telephone"
                                  v-bind:label="$t('phoneNumber')"
                                >
                                  <el-input
                                    v-bind:placeholder="$t('phoneNumber')"
                                    v-model="addAddressForm.Telephone"
                                    @input="phoneXPOFormatter(addAddressForm.Telephone)"
                                  ></el-input>
                                </el-form-item>
                              </div>
                            </el-col>
                          </el-row>
                          <el-row :gutter="20">
                            <el-col :span="24">
                              <el-form-item
                                prop="Residential"
                                v-bind:label="$t('Residential')"
                                style="display: flex"
                              >
                                <el-radio-group v-model="addAddressForm.Residential">
                                  <el-radio :label="true">Yes</el-radio>
                                  <el-radio :label="false">No</el-radio>
                                </el-radio-group>
                              </el-form-item>
                            </el-col>
                          </el-row>
                          <div class="input_box" style="display: flex">
                            <span style="color:black">{{ $t("country") }} &nbsp;&nbsp;</span>
                            <el-radio v-model="addAddressForm.Country" label="US">{{ $t("usa") }}</el-radio>
                            <el-radio v-model="addAddressForm.Country" label="CN">{{ $t("canada") }}</el-radio>
                          </div>
                          <el-row :gutter="20">
                            <el-col :span="12">
                              <el-form-item
                                prop="Street"
                                v-bind:label="$t('street')"
                              >
                                <el-input
                                  v-bind:placeholder="$t('street')"
                                  v-model="addAddressForm.Street"
                                ></el-input>
                              </el-form-item>
                            </el-col>
                            <el-col :span="12">
                              <div class="width">
                                <el-form-item prop="City" v-bind:label="$t('city')">
                                  <el-input
                                    v-bind:placeholder="$t('city')"
                                    v-model="addAddressForm.City"
                                  ></el-input>
                                </el-form-item>
                              </div>
                            </el-col>
                          </el-row>
                          
                          <div v-if="addAddressForm.Country==='US'">
                            <el-row :gutter="20">
                              <el-col :span="12">
                                <el-form-item prop="State" v-bind:label="$t('state')">
                                  <el-select
                                    v-model="addAddressForm.State"
                                    v-bind:placeholder="$t('pleaseSelect')"
                                    value=""
                                  >
                                    <el-option
                                      v-for="item in stateOptions"
                                      :key="item.value"
                                      :label="item.label"
                                      :value="item.value"
                                    >
                                    </el-option>
                                  </el-select>
                                </el-form-item>
                              </el-col>
                              <el-col :span="12">
                                <div class="width">
                                  <el-form-item prop="Zip" v-bind:label="$t('zipCode')">
                                    <el-input v-bind:placeholder="$t('zipCode')" v-model="addAddressForm.Zip" ></el-input>
                                  </el-form-item>
                                </div>
                              </el-col>
                            </el-row>
                          </div>
                          <div v-else>
                            <el-row :gutter="20">
                              <el-col :span="12">
                                <el-form-item prop="State" v-bind:label="$t('state')">
                                  <el-select
                                    v-model="addAddressForm.State"
                                    v-bind:placeholder="$t('pleaseSelect')"
                                    value=""
                                  >
                                    <el-option
                                      v-for="item in caStateOptions"
                                      :key="item.value"
                                      :label="item.label"
                                      :value="item.value"
                                    >
                                    </el-option>
                                  </el-select>
                                </el-form-item>
                              </el-col>
                              <el-col :span="12">
                                <div class="width">
                                  <el-form-item prop="Zip" v-bind:label="$t('zipCode')">
                                    <el-input v-bind:placeholder="$t('zipCode')" v-model="addAddressForm.Zip" ></el-input>
                                  </el-form-item>
                                </div>
                              </el-col>
                            </el-row>
                          </div>
                          
                        </div>
                        <div class="end">
                          <button
                            style="marginTop: 30px"
                            class="btn"
                            @click="submitNewAddress(addAddressForm, $event)"
                          >
                            {{ $t("submit") }}
                          </button>
                        </div>
                      </div>
                    </el-form>
                  </el-dialog>
                  <!-- add address end -->
                </div>
                <button
                  class="place btn"
                  @click="onSubmit(orderForm, $event)"
                >
                  {{ $t("createQuote") }}
                </button>
              </div>
            </main>
          </div>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
  import {mapState, mapMutations, mapActions} from "vuex";
  import {Alert} from "element-ui";
  import axios from "axios";
  import breadcrumb from "../../components/breadcrumb";
  import logo from "../../assets/img/logo.png";
  import addresses from "../../store/modules/addresses";
  import {deleteCustomerDetail} from "../../store/modules/addresses";
  import {validateUSZipCode, validateCAZipCode, validatePhoneNumber} from "../../../config/validation";

  export default {
    name: "outboundXPO",
    components: {
      breadcrumb,
    },
    data() {
      return {
        errors: [],
        stateOptions: this.$store.state.addresses.states,
        caStateOptions: this.$store.state.addresses.ca_states,

        multipleSelection: [],
        lableFile: [],
        pickupServiceOptions: ['OSH','OLG','RSO'],
        deliveryServicesOptions: ['DAH','APT','DSH','DLG','DNC','RSD'],

        calFreightClassVisible: false,
        freightClassForm: {
          error: '',
          totalCubes: 0,
          totalWeight: 0,
          totalDensity: 0,
          freightClass: 0,
          
          pallet: [{
            length: 0,
            width: 0,
            height: 0,
            weight: 0,
          }],
        },
        // Order form data
        orderForm: {
          //customer info
          // OrderDate: "",
          ShipmentDate: "",
          Carrier: "xpo",
          Signature: "",
          Pickup_Warehouse_id: "",
          SelfDrayage: false,
          ExcessValue: "",
          // ShipFrom: "",
          Deliver_CustomerDetail_id: "",
          IsOutbound: true,
          IsNoReduce: false,
          RefNum: "",
          //ship info
          lines: [],
          totalWeight: 0,
          // pickupServices, deliveryServices
          XPOAccessorials: []
        },
        
        // add address data
        addressModalVisible: false,
        errorAdding: false,
        addAddressForm: {
          Type: "Billing",
          FirstName: "",
          LastName: "",
          Residential: true,
          Street: "",
          Telephone: "",
          Email: "",
          City: "",
          Zip: "",
          Country: "US",
          State: "",
          AddressName: "",
          AptNumber: "",
        },
        
        errorSubmitting: false,
        success: false,
        submmited: false,
        path2: this.$t("ltl"),
      };
    },
    computed: mapState({
      inboundProducts: state => state.orders.inboundProducts,
      billingAddresses: (state) => state.addresses.billingAddresses,
      warehouseAddresses: (state) => state.addresses.warehouseAddresses,
    }),
    methods: {
      ...mapActions("orders", [ "submit", "submitOutboundLabel" ]),
      ...mapMutations("warehouseOrder", ["getOrderDetail"]),
      addNewLine() {
        if (this.multipleSelection) {
          this.multipleSelection.forEach(row => {
            if (row) {
              this.orderForm.lines.unshift({...row});
            }
          });
        }
      },
      deleteRow(index, rows) {
        rows.splice(index, 1);
      },
      resetFreightClass(event) {
        event.preventDefault();
        this.freightClassForm = {
          error: '',
          totalCubes: 0,
          totalWeight: 0,
          totalDensity: 0,
          freightClass: 0,
          
          pallet: [{
            length: 0,
            width: 0,
            height: 0,
            weight: 0,
          }],
        };
      },
      getFreightClass(event) {
        let cubes = 0;
        let lbs = 0;
        let error = '';
        this.freightClassForm.error = error;
        
        let newLines = this.freightClassForm.pallet.map((p) =>  {
          cubes += (p.length * p.width * p.height) / 1728;
          lbs += p.weight;
          if (p.length === 0 || p.width === 0 || p.height === 0 || p.weight===0 ) {
            this.freightClassForm.error = 'value can not be 0';
          }
        });
        
        this.freightClassForm.totalCubes = cubes.toFixed(2);
        this.freightClassForm.totalWeight = lbs.toFixed(2);
        let density = lbs.toFixed(2)/cubes.toFixed(2);
        this.freightClassForm.totalDensity = density.toFixed(2);
         
        if (density<1) { this.freightClassForm.freightClass = 400; }
        else if (density<2) { this.freightClassForm.freightClass = 300; }
        else if (density<4) { this.freightClassForm.freightClass = 250; }
        else if (density<6) { this.freightClassForm.freightClass = 175; }
        else if (density<8) { this.freightClassForm.freightClass = 125; }
        else if (density<10) { this.freightClassForm.freightClass = 100; }
        else if (density<12) { this.freightClassForm.freightClass = 92.5; }
        else if (density<15) { this.freightClassForm.freightClass = 85; }
        else if (density<22.5) { this.freightClassForm.freightClass = 70; }
        else if (density<30) { this.freightClassForm.freightClass = 65; }
        else { this.freightClassForm.freightClass = 60; }
      },
      addPallet() {
        this.freightClassForm.pallet.push({
          length: 0,
          width: 0,
          height: 0,
          weight: 0,
        });
      },
      // address method
      resetForm() {
        this.addAddressForm = {
          Type: "Billing",
          FirstName: "",
          LastName: "",
          Residential: true,
          Street: "",
          Telephone: "",
          Email: "",
          City: "",
          Zip: "",
          Country: "US",
          State: "",
          AddressName: "",
        };
        this.orderForm = {
          // OrderDate: "",
          ShipmentDate: "",
          Carrier: "xpo",
          Signature: "",
          ExcessValue: "",
          Pickup_Warehouse_id: "",
          SelfDrayage: false,
          Deliver_CustomerDetail_id: "",
          IsOutbound: true,
          IsNoReduce: false,
          RefNum: "",
          lines: [],
          totalWeight: 0,
          XPOAccessorials: []
        };
      },
      openCalFreightClass(event) {
        event.preventDefault();
        this.calFreightClassVisible = true;
      },
      closeCalFreightClass(event) {
        event.preventDefault();
        this.calFreightClassVisible = false;
        this.freightClassForm = {
          error: '',
          totalCubes: 0,
          totalWeight: 0,
          totalDensity: 0,
          freightClass: 0,
          
          pallet: [{
            length: 0,
            width: 0,
            height: 0,
            weight: 0,
          }],
        };
      },
      handleClose(event) {
        event.preventDefault();
        this.$refs['addWarehouseAddressForm'].resetForm();
        this.addressModalVisible = false;
      },
      checkAddressForm: async function (form) {
        this.errors = [];
        if (!form.Street) {
          this.errors.push(this.$t("addressRequired"));
        }
        if (!form.City) {
          this.errors.push(this.$t("cityRequired"));
        }
        if (!form.Country) {
          this.errors.push(this.$t("countryRequired"));
        }
        if (!form.State) {
          this.errors.push(this.$t("stateRequired"));
        }
        if (!form.AddressName) {
          this.errors.push(this.$t("companyNameRequired"));
        }
        if (form.Country === 'US') {
          if (validateUSZipCode(form.Zip)) this.errors.push(this.$t("zipCodeWrong"));
        } else {
          if (validateCAZipCode(form.Zip)) this.errors.push(this.$t("zipCodeWrong"));
        }
      },
      phoneXPOFormatter(value) {
        // NNN-NNNNNNN
        var cleaned = ('' + value).replace(/\D/g, '');
        var match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
        
        if (match) {
          this.addAddressForm.Telephone = match[1] + '-' + match[2] + match[3];
          // return match[1] + '-' + match[2] + match[3];
        }
      },
      submitNewAddress(address, event) {
        this.errors = []
        event.preventDefault();
        this.checkAddressForm(address);
        
        if (!this.errors.length) {
          this.$store.dispatch("addresses/postAddress", address).then(() => {
            this.$store.dispatch("addresses/fetchAddresses");
            this.resetForm();
            this.addressModalVisible = false;
          });
        } else {
          alert(this.errors);
        }
      },
      // Method for file
      handleFileImport(file, fileList) {
        this.lableFile = fileList;
        // this.updateFileList(fileList, 0); 
      },
      beforeFileRemove(file, fileList) {
        return this.$confirm(`Remove ${ file.name } ?`);
      },
      handleFileRemove(file, fileList) {
        this.lableFile = [];
        // this.updateFileList(fileList, 0);
      },
      updateFileList(fileList, id) {
        var formData = new FormData();
        formData.append('file', fileList[0].raw);
        this.submitOutboundLabel([formData, id]);
      },
      handleSelectionChange(rows) {
        this.multipleSelection = rows;
      },
      checkTable(lines) {
        if (lines.length === 0) {
          this.errors.push("Please select product.");
        } 
        const check = lines.every(element => element.PalletWeight === '' || element.PalletWeight === '0');
        if (check === true) {
          this.errors.push("a valid number is required for pallet weight");
        }
      },
      onSubmit(orderForm, event) {
        event.preventDefault();
        this.errors = [];
        this.errorSubmitting = false;
        this.checkTable(orderForm.lines);
        
        // if (orderForm.OrderDate) {
        //   orderForm.OrderDate = moment(orderForm.OrderDate).format();
        // }
        if (orderForm.ShipmentDate) {
          orderForm.ShipmentDate = moment(orderForm.ShipmentDate).format();
        }
        
        orderForm.Deliver_CustomerDetail_id = orderForm.Billing_CustomerDetail_id;
        
        let newLines = orderForm.lines.map((line) =>  {
          return {
            ...line,
            TotalNetWeight: line.PalletWeight * line.PalletQuantity,
            PalletVol: line.PalletLength * line.PalletWidth * line.PalletHeight,
          };
        });
        orderForm.lines = newLines;

        // get total ExcessValue
        const sum = this.orderForm.lines.reduce((acc, item) => {
          return acc + Number(item.ExcessValue);
        }, 0);
        orderForm.ExcessValue = sum;
        
        if (this.lableFile.length > 0) {
          orderForm.SelfDrayage = true;
        }
        // check
        if (!this.errors.length) {
          this.submit(orderForm)
            .then((res) => {
              this.errors = "";
              if (this.lableFile.length > 0) {
                this.updateFileList(this.lableFile, res.data.SalesOrder_id);
              }
              this.openAlert(res.data.SalesOrder_id); // show success message
              this.resetForm();
            })
            .catch((err) => {
              if (err.response.data.message) {
                alert(err.response.data.message);
              } else {
                alert(err.response.data);
              }
            });
        } else {
          this.errorSubmitting = true;
          alert(this.errors);
        }
      },
      openAlert(id) {
        // this.submmited = true;
        let message = "You have submitted an outbound order.";
        this.$alert(message, "Success", {
          confirmButtonText: "Go to order detail",
          type: "success",
          center: true,
        }).then(() => {
          this.$router.push({name: 'order', params: {order_id: id}});
        });
      },
    },
    mounted() {
      this.$store.dispatch('orders/fetchInboundProducts');
      this.$store.dispatch("addresses/fetchAddresses");
      this.$store.dispatch("addresses/fetchWarehouseAddresses");
    },
  };
</script>

<style lang="less">
  @import "../../assets/css/warehouseOrder.less";
</style>



// WEBPACK FOOTER //
// src/view/Service/outboundXPO.vue